// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rtr-overlay {
  position: fixed;
  inset: 0;
  z-index: 100000000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(8, 10, 14, 0.7);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  animation: rtr-fade-in 0.2s ease;
}

.rtr-modal {
  position: relative;
  width: 100%;
  max-width: 420px;
  padding: 28px 24px 24px;
  border-radius: 16px;
  background: #191C1E;
  border: 1px solid #373E4B;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
  text-align: center;
  color: #e6e8ec;
  font-family: "Inter", sans-serif;
  animation: rtr-pop-in 0.25s cubic-bezier(0.22, 1, 0.36, 1);
}

.rtr-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: #b5b9c3;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.rtr-close:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.rtr-icon {
  width: 64px;
  height: 64px;
  margin: 4px auto 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 30px;
  color: #1E56F5;
  background: radial-gradient(circle at 30% 30%, rgba(30, 86, 245, 0.28), rgba(30, 86, 245, 0.08));
  border: 1px solid rgba(30, 86, 245, 0.4);
}

.rtr-title {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.rtr-message {
  margin: 0 auto 18px;
  max-width: 340px;
  font-size: 14px;
  line-height: 1.5;
  color: #aab0bd;
}

.rtr-progress-wrap {
  margin: 0 0 20px;
  text-align: left;
}

.rtr-progress-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 12px;
  color: #aab0bd;
}

.rtr-progress-track {
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
}

.rtr-progress-bar {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #1E56F5, #4f7dff);
  transition: width 0.4s ease;
}

.rtr-actions {
  display: flex;
  gap: 10px;
}

.rtr-btn {
  flex: 1 1;
  padding: 11px 14px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  transition: transform 0.12s ease, opacity 0.15s ease, background 0.15s ease;
}

.rtr-btn:active {
  transform: translateY(1px);
}

.rtr-btn--ghost {
  background: transparent;
  border-color: #373E4B;
  color: #c9cdd6;
}

.rtr-btn--ghost:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: #4a5360;
}

.rtr-btn--primary {
  background: #1E56F5;
  border-color: #1E56F5;
  color: #fff;
}

.rtr-btn--primary:hover {
  opacity: 0.92;
}

@keyframes rtr-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes rtr-pop-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 480px) {
  .rtr-modal {
    max-width: 100%;
    padding: 24px 18px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/customComponents/ReferralTaskReminderModal/referralTaskReminder.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,kCAA0B;UAA1B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gGAAgG;EAChG,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,2EAA2E;AAC7E;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;AACF","sourcesContent":[".rtr-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 100000000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(8, 10, 14, 0.7);\n  backdrop-filter: blur(4px);\n  animation: rtr-fade-in 0.2s ease;\n}\n\n.rtr-modal {\n  position: relative;\n  width: 100%;\n  max-width: 420px;\n  padding: 28px 24px 24px;\n  border-radius: 16px;\n  background: #191C1E;\n  border: 1px solid #373E4B;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);\n  text-align: center;\n  color: #e6e8ec;\n  font-family: \"Inter\", sans-serif;\n  animation: rtr-pop-in 0.25s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.rtr-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.06);\n  color: #b5b9c3;\n  font-size: 18px;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.rtr-close:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: #fff;\n}\n\n.rtr-icon {\n  width: 64px;\n  height: 64px;\n  margin: 4px auto 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 30px;\n  color: #1E56F5;\n  background: radial-gradient(circle at 30% 30%, rgba(30, 86, 245, 0.28), rgba(30, 86, 245, 0.08));\n  border: 1px solid rgba(30, 86, 245, 0.4);\n}\n\n.rtr-title {\n  margin: 0 0 8px;\n  font-size: 20px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.rtr-message {\n  margin: 0 auto 18px;\n  max-width: 340px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #aab0bd;\n}\n\n.rtr-progress-wrap {\n  margin: 0 0 20px;\n  text-align: left;\n}\n\n.rtr-progress-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 6px;\n  font-size: 12px;\n  color: #aab0bd;\n}\n\n.rtr-progress-track {\n  width: 100%;\n  height: 8px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  overflow: hidden;\n}\n\n.rtr-progress-bar {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #1E56F5, #4f7dff);\n  transition: width 0.4s ease;\n}\n\n.rtr-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.rtr-btn {\n  flex: 1;\n  padding: 11px 14px;\n  border-radius: 50px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: transform 0.12s ease, opacity 0.15s ease, background 0.15s ease;\n}\n\n.rtr-btn:active {\n  transform: translateY(1px);\n}\n\n.rtr-btn--ghost {\n  background: transparent;\n  border-color: #373E4B;\n  color: #c9cdd6;\n}\n\n.rtr-btn--ghost:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: #4a5360;\n}\n\n.rtr-btn--primary {\n  background: #1E56F5;\n  border-color: #1E56F5;\n  color: #fff;\n}\n\n.rtr-btn--primary:hover {\n  opacity: 0.92;\n}\n\n@keyframes rtr-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes rtr-pop-in {\n  from {\n    opacity: 0;\n    transform: translateY(12px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (max-width: 480px) {\n  .rtr-modal {\n    max-width: 100%;\n    padding: 24px 18px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
